import React, { useEffect } from 'react'
import $ from 'jquery'
// import gsap from 'gsap/dist/gsap';
import gsap from 'gsap/gsap-core';
import "../css/Check.css"

function Check() {
    let xPos = 0;

    useEffect(() => {
        gsap.timeline()
            .set('.ring', { rotationY: 180, cursor: 'grab' }) //set initial rotationY so the parallax jump happens off screen
            .set('.img', { // apply transform rotations to each image
                rotateY: (i) => i * -36,
                transformOrigin: '50% 50% 500px',
                z: -500,
                backgroundImage: (i) => `doveimg${i}`,
                backgroundPosition: (i) => getBgPos(i),
                backfaceVisibility: 'hidden'
            })
            .from('.img', {
                duration: 1.5,
                y: 200,
                opacity: 0,
                stagger: 0.1,
                ease: 'expo'
            })
            .add(() => {
                $('.img').on('mouseenter', (e) => {
                    let current = e.currentTarget;
                    gsap.to('.img', { opacity: (i, t) => (t == current) ? 1 : 0.5, ease: 'power3' })
                })
                $('.img').on('mouseleave', (e) => {
                    gsap.to('.img', { opacity: 1, ease: 'power2.inOut' })
                })
            }, '-=0.5')

        $(window).on('mousedown touchstart', dragStart);
        $(window).on('mouseup touchend', dragEnd);


    }, [])


    function dragStart(e) {
        if (e.touches) e.clientX = e.touches[0].clientX;
        xPos = Math.round(e.clientX);
        gsap.set('.ring', { cursor: 'grabbing' })
        $(window).on('mousemove touchmove', drag);
    }


    function drag(e) {
        if (e.touches) e.clientX = e.touches[0].clientX;

        gsap.to('.ring', {
            rotationY: '-=' + ((Math.round(e.clientX) - xPos) % 360),
            onUpdate: () => { gsap.set('.img', { backgroundPosition: (i) => getBgPos(i) }) }
        });

        xPos = Math.round(e.clientX);
    }


    function dragEnd(e) {
        $(window).off('mousemove touchmove', drag);
        gsap.set('.ring', { cursor: 'grab' });
    }


    function getBgPos(i) { //returns the background-position string to create parallax movement in each image
        return (100 - gsap.utils.wrap(0, 360, gsap.getProperty('.ring', 'rotationY') - 180 - i * 36) / 360 * 500) + 'px 0px';
    }
    return (
        <div className="stage">


            <div className="container__check">
                <div className="ring">
                    <div className="img"></div>
                    <div className="img"></div>
                    <div className="img"></div>
                    <div className="img"></div>
                    <div className="img"></div>
                    <div className="img"></div>
                    <div className="img"></div>
                    <div className="img"></div>
                    <div className="img"></div>
                    <div className="img"></div>
                </div>
            </div>

        </div>
    )
}

export default Check

{/* <div className="effect__wrap">
                    <div className="effect effect-2">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div className="effect effect-3"></div>
                    <div className="effect effect-4"></div>
                    <div className="effect effect-5">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div> */}